<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { PinInputInput, type PinInputInputProps, useForwardProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<PinInputInputProps & { class?: HTMLAttributes["class"] }>()

const forwardedProps = useForwardProps(() => props)

const className = useClass(
	"relative text-center focus:outline-none focus:ring-2 focus:ring-ring focus:relative focus:z-10 flex size-10 items-center justify-center border-y border-r border-input text-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
	() => rawClass,
)
</script>

<template>
	<PinInputInput
		v-bind="forwardedProps"
		:class="className" />
</template>
